export const monitoring = [
  {
    title: "A. Monitoring SIPDAR-PQ",
    description:
      "Aplikasi Untuk Monitoring lembaga yang sudah mengajukan Permohonan pada aplikasi SIPDAR-PQ",
    imgUrl: "https://source.unsplash.com/1600x1200?alquran",
    link: "https://bit.ly/Rekapitulasi_SIPDAR-PQ",

    deadline: "",
  },
  {
    title: "B. Peraturan dan Juknis",
    description: "Kumpulan peraturan dan juknis",
    imgUrl: "https://source.unsplash.com/1600x1080?alquran",
    link: "https://drive.google.com/drive/folders/1Oq3PKpdhisjKUyt_iNjG-46ukMhZfqSL?usp=sharing",

    deadline: "",
  },
  {
    title: "C. Monitoring Update data EMIS",
    description: "Aplikasi untuk memonitoring update data EMIS",
    imgUrl:
      "https://github.com/kkafi09/pdpontren-kemenagkota/blob/main/src/images/emis-wajib.png?raw=true",
    link: "https://docs.google.com/spreadsheets/d/1_g-tjIl7DZ4qN6nIzYvDAV0dPZPLQObUiZLwu8JwOAM/edit?usp=sharing",
    deadline: "",
  },
];
